/*jshint esversion: 6 */

import React, { Component } from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
// import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import ProtectedRoute from "./hoc/ProtectedRoute/ProtectedRoute";
import Message from "./components/UI/Message/Message";

import "./App.css";

import * as actions from "./store/actions/index";
//import asyncComponent from "./hoc/asyncComponent/asyncComponent";
import Auth from "./containers/Auth/Auth";
import axios from "axios";
import DateFnsUtils from "@date-io/date-fns";
import Layout from "./hoc/Layout/Layout";
import LandingPage from "./components/Navigation/LandingPage/LandingPage";
import Logout from './containers/Auth/Logout/Logout';
import ManageDB from "./containers/ManageDB/ManageDB";
import Reports from "./containers/Reports/Reports";
import Review from "./containers/Review/Review";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { doLog, setAppOptions, setServerAppPath, hasValue, setLogging } from "./shared/utility";
import * as queryString from "query-string";
// import { string } from "prop-types";

// const asyncAuth = asyncComponent(() => {
//   return import("./containers/Auth/Auth");
// });

// const asyncSettings = asyncComponent(() => {
//   return import("./containers/Settings/Settings");
// });

class App extends Component {
  componentDidMount() {
    let pathname = window.location.pathname;

    if (pathname.endsWith('/'))
      pathname = pathname.substring(0, pathname.length - 1);
    if (doLog()) console.log("[APP] componentDidMount pathname:" + pathname);
    if (doLog()) console.log("[APP] componentDidMount href:" + window.location.href);
    if (doLog()) console.log("[APP] componentDidMount hostname:" + window.location.hostname);
    if (doLog()) console.log("[APP] componentDidMount protocol:" + window.location.protocol);
    if (doLog()) console.log("[APP] componentDidMount port:" + window.location.port);
    if (doLog()) console.log("[APP] componentDidMount origin:" + window.location.origin);
    if (doLog()) console.log("[APP] componentDidMount host:" + window.location.host);

    if (doLog()) console.log("[APP] componentDidMount props:", this.props);
    const params = queryString.parse(this.props.location.search);
    if (doLog()) console.log("[APP] componentDidMount params:", params);
    setAppOptions(params);

    let productionMode = this.props.productionMode
    let agencyCode = params.agency;
    // Set agencyCode from URL params first, then from props if not in URL
    if (hasValue(agencyCode)) {
      this.props.onSetAgencyCode(agencyCode);
    } else if (hasValue(this.props.agencyCode)) {
      agencyCode = this.props.agencyCode;
    }
    if (doLog()) console.log("[APP] componentDidMount agencyCode:" + agencyCode);

    let logging = params.logging;
    const logOption = params["log"];
    if (hasValue(logOption) && logOption.toUpperCase().startsWith("T")) {
      logging = true;
    }

    if (hasValue(logging)) {
      setLogging(logging);
    }

    let baseURL = null;
    if (productionMode) {
      baseURL = window.location.origin;
      if (doLog()) console.log("[APP] componentDidMount productionMode baseURL:" + baseURL);
    } else {
      const defaultIP = "localhost";
      // const defaultPort = 8080;
      // const defaultProtocol = 'https';
      const defaultPort = 8081;
      const defaultProtocol = "http";
      baseURL = defaultProtocol + "://" + defaultIP + ":" + defaultPort;
      const ip = localStorage.getItem("AMIP");
      const port = localStorage.getItem("AMPort");
      const protocol = localStorage.getItem("AMProtocol");
      if (ip != null && port != null && protocol != null) {
        baseURL = protocol + "://" + ip + ":" + port;
        if (doLog()) console.log("[APP] componentDidMount developmentMode baseURL changed to:" + baseURL);
      } else {
        // localStorage.setItem("AMIP", defaultIP);
        // localStorage.setItem("AMPort", defaultPort);
        // localStorage.setItem("AMProtocol", defaultProtocol);
        baseURL = window.location.origin;
        if (doLog()) console.log("[APP] componentDidMount developmentMode baseURL:" + baseURL);
      }
    }
    axios.defaults.baseURL = baseURL;

    this.props.onSetServerInfo(baseURL, pathname);
    setServerAppPath(this.props.serverAppPath);

    if (this.props.configuration === null) {
      this.props.onFetchConfiguration(agencyCode, this.props.token);
    }

    //Make the URL reflect the original URL to make it easier to set up a browser favorite.
    // const updatedURL = window.location.origin + pathname + "/" + this.props.location.search;
    const updatedURL = window.location.origin + pathname + this.props.location.search;
    if (doLog()) console.log("[App] render updatedURL:" + updatedURL);
    window.history.replaceState("", "", updatedURL);
  }

  render() {
    const agencyCode = this.props.agencyCode;
    if (doLog()) console.log("[App] render agencyCode:" + agencyCode);

    if (!agencyCode) {
      return (
        <Message type="error">
          An agency parameter is required. Please add '?agency=YOUR_AGENCY_CODE' to the URL.
        </Message>
      );
    }

    let routes = (
      // <Routes>
      <Switch>
        <Route path="/auth" component={Auth} />
        <Route path="/" exact component={LandingPage} />
        <Redirect to="/" />
        {/* <Route Navigate to="/" /> */}
      </Switch>
      // </Routes>
    );

    if (doLog()) console.log("[App] render isAuthenticated:" + this.props.isAuthenticated);
    // if (doLog()) console.log("[App] render agencyCode:" + this.props.agencyCode);
    if (doLog()) console.log("[App] render agencyCode:" + agencyCode);
    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          <Route path="/auth" component={Auth} />
          <Route path="/logout" component={Logout} />
          <ProtectedRoute
            path="/managedb"
            exact
            component={ManageDB}
            isAuthenticated={this.props.isAuthenticated}
          />
          <ProtectedRoute
            path="/reports"
            exact
            component={Reports}
            isAuthenticated={this.props.isAuthenticated}
          />
          <ProtectedRoute
            path="/review"
            exact
            component={Review}
            isAuthenticated={this.props.isAuthenticated}
          />
          <Route path="/" exact component={LandingPage} />
          <Redirect to="/" />
        </Switch>
      );
    }

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {/* <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}> */}
        <div>
          {/* <Layout agencyCode={this.props.agencyCode}>{routes}</Layout> */}
          <Layout agencyCode={agencyCode}>{routes}</Layout>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    configuration: state.trans.configuration,
    incidentTypeList: state.trans.incidentTypeList,
    agencyCode: state.trans.agencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAuthSignup: () => dispatch(actions.authCheckState()),
    onFetchConfiguration: (agencyCode, token) =>
      dispatch(actions.fetchConfiguration(agencyCode, token)),
    onSetConfigurationDefaults: (configuration) =>
      dispatch(actions.setConfigurationDefaults(configuration)),
    onSetAgencyCode: (agencyCode) => dispatch(actions.setAgencyCode(agencyCode)),
    onSetServerInfo: (baseURL, pathname) => dispatch(actions.setServerInfo(baseURL, pathname))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
// export default connect(mapStateToProps, mapDispatchToProps)(App);
